import React from 'react';

export const geolocation = (color = 'rgba(125,125,125, 0.5)', filled = true, width = 21, height = 21) => (
  <svg width={width} height={height} viewBox='0 0 64 64' xmlns='http://www.w3.org/2000/svg'>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M56.381 24.381C56.381 10.914 45.468 0 32 0 18.536 0 7.619 10.914 7.619 24.381a24.276 24.276 0 0 0 5.355 15.238h-.022L32 64l19.048-24.381h-.021a24.277 24.277 0 0 0 5.354-15.238zM32 33.523a9.143 9.143 0 0 1-9.143-9.143A9.141 9.141 0 0 1 32 15.237a9.143 9.143 0 0 1 0 18.286z'
      fill={filled ? color : 'none'}
    />
  </svg>
);
